module.exports = __webpack_public_path__ + "img/wechat.574ebf82.svg";